import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// Component for protected routes that require authentication
export const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="d-flex justify-content-center mt-5"><div className="spinner-border" role="status"></div></div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

// Component for routes that require admin or manager role
export const AdminRoute = () => {
  const { isAuthenticated, isLoading, currentUser } = useContext(AuthContext);

  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="d-flex justify-content-center mt-5"><div className="spinner-border" role="status"></div></div>;
  }

  // Check if user is authenticated and has admin or manager role
  const isAdminOrManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';
  return isAuthenticated && isAdminOrManager ? 
    <Outlet /> : 
    <Navigate to="/login" />;
};

// Component for routes that should only be accessible when not logged in
export const PublicRoute = () => {
  const { isAuthenticated, isLoading, currentUser } = useContext(AuthContext);

  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="d-flex justify-content-center mt-5"><div className="spinner-border" role="status"></div></div>;
  }

  // Redirect to appropriate dashboard if already logged in
  if (isAuthenticated) {
    const isAdminOrManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';
    return isAdminOrManager ? 
      <Navigate to="/admin/dashboard" /> : 
      <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};
